import React from 'react';
import { Link } from 'react-router-dom';
import { QrCode, Sparkles, Users, BadgeCheck, ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export default function PassLanding() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Helmet>
        <title>Todo en Local Pass — Promociones y experiencias locales</title>
      </Helmet>

      <header className="bg-slate-900 text-white">
        <div className="max-w-6xl mx-auto px-6 py-20 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-500/20 text-teal-300 text-xs font-semibold mb-6">
            <Sparkles className="w-3.5 h-3.5" /> Piloto en Puerto Vallarta
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Gana más clientes. Gana más comisiones.
          </h1>
          <p className="text-slate-300 max-w-2xl mx-auto mb-8">
            Todo en Local Pass conecta negocios locales con promotores, taxistas y clientes usando QR,
            promociones y reservas reales.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/register"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange-500 hover:bg-orange-600 rounded-lg font-semibold transition"
            >
              Soy negocio, quiero vender más <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/pass/affiliate"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-teal-500 hover:bg-teal-600 rounded-lg font-semibold transition"
            >
              Quiero ganar recomendando <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </header>

      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-6">
          <Card icon={QrCode} title="QR personalizado" body="Cada afiliado recibe un QR único y un PDF imprimible listo para enmicar y colgar en su taxi, van o recepción." />
          <Card icon={Users} title="Mini catálogo personalizado" body="Recomienda solo los productos o servicios que más te gusten — restaurantes, yates, tours, antros, joyerías y más." />
          <Card icon={BadgeCheck} title="Pagas solo por resultados" body="Comisiones se liberan al check-in real. Sin venta, sin pago. Sin riesgo para el negocio." />
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Para negocios</h2>
            <ul className="space-y-2 text-slate-700">
              <li>• Publica promociones y experiencias.</li>
              <li>• Define la comisión que ofreces a los promotores.</li>
              <li>• Recibe clientes con QR y haz check-in desde tu celular.</li>
              <li>• Las ofertas aparecen también en el marketplace público.</li>
            </ul>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Para afiliados</h2>
            <ul className="space-y-2 text-slate-700">
              <li>• Crea tu QR personal y descarga material imprimible.</li>
              <li>• Elige qué recomendar y comparte por WhatsApp.</li>
              <li>• Cobra comisión cuando el cliente llega y consume.</li>
              <li>• Mide cuántos escaneos y check-ins generas.</li>
            </ul>
          </div>
        </div>
      </section>

      <footer className="bg-slate-900 text-slate-400 py-8 text-center text-sm">
        © Todo en Local Pass — todoenlocal.com
      </footer>
    </div>
  );
}

function Card({ icon: Icon, title, body }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
      <Icon className="w-8 h-8 text-teal-600 mb-3" />
      <h3 className="font-semibold text-slate-900 mb-1">{title}</h3>
      <p className="text-sm text-slate-600">{body}</p>
    </div>
  );
}
